import React from 'react';
import './GDDueDateCell.scss';
import PropTypes from 'prop-types';
import moment from 'moment';

const parseDate = (timeStamp, dateFormat, isMerchantPortal) => {
  return (
    <div>
      <span className="gd-due-date-cell__value gd-due-date-cell__margin-top">
      {moment(timeStamp).format(dateFormat)}
      </span>
    </div>
  );
};

const GDDueDateCell = ({ dueDate, dueDateDescription, dateFormat, extraClass, isMerchantPortal }) => {
  return (
    <div className="extraClass">
      {parseDate(dueDate, dateFormat,isMerchantPortal)}
      <span className="gd-due-date-cell__due-date">{dueDateDescription} Days Left</span>
    </div>
  );
};

GDDueDateCell.propTypes = {
  dueDate: PropTypes.string.isRequired,
  dueDateDescription: PropTypes.any.isRequired,
  dateFormat: PropTypes.string.isRequired,
};

GDDueDateCell.defaultProps = {
  dueDate: '',
  dateFormat: 'MM/DD/YYYY',
  extraClass: '',
};

export default GDDueDateCell;
